"use client";

import { XIcon } from "lucide-react";
import Image from "@components/Image";
import { Heading } from "@components/ui";
import { Popover, Transition, TransitionChild } from "@headlessui/react";
import { Fragment } from "react";

import { cn } from "@/lib/utils";

/**
 * @deprecated
 */
const Swatch = ({
  name,
  imgUrl,
  disabled,
}: {
  name: string;
  imgUrl: string;
  disabled?: boolean;
}) => (
  <Popover as={Fragment}>
    <Popover.Button
      className={cn("action-focus mr-2", disabled && "pointer-events-none")}
    >
      <Image
        className="max-w-6"
        src={imgUrl}
        alt={name}
        widths={[50]}
        priority
      />
    </Popover.Button>

    <Transition
      as="div"
      className={cn(
        "fixed inset-0 z-10 grid max-h-screen place-items-center overflow-y-auto text-lg",
      )}
    >
      <Popover.Panel className="mx-2 flex" onClick={(e) => e.preventDefault()}>
        {({ close }) => (
          <>
            <div
              className="fixed inset-0 bg-black/25"
              onClick={() => close()}
              aria-hidden
            />
            <TransitionChild
              as="div"
              className="w-full max-w-[30rem] grow bg-white"
              enter="transition duration-100 ease-out"
              enterFrom="scale-95 opacity-0"
              enterTo="scale-100 opacity-100"
              leave="transition duration-75 ease-out"
              leaveFrom="scale-100 opacity-100"
              leaveTo="scale-95 opacity-0"
            >
              <header className="grid grid-cols-[3rem_1fr_3rem] items-center text-center">
                <Heading className="col-start-2 text-sm font-normal md:text-base">
                  {name}
                </Heading>
                <button
                  type="button"
                  onClick={() => close()}
                  className="ml-auto p-2"
                >
                  <XIcon strokeWidth={1} className="size-4.5" />
                </button>
              </header>
              <Image
                className="aspect-square w-full px-2 pb-2"
                src={imgUrl}
                alt={name}
                widths={[1000]}
              />
            </TransitionChild>
          </>
        )}
      </Popover.Panel>
    </Transition>
  </Popover>
);

export default Swatch;
